import { InputHTMLAttributes } from 'react';
import { Field } from 'react-final-form';

export interface FormFieldCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string,
  name: string,
}

const FormFieldCheckbox = ({
  label,
  name,
  ...checkboxProps
}: FormFieldCheckboxProps) => (
  <Field name={name} type="checkbox">
    {({ input, meta }) => (
      <div className="flex items-center space-x-2 mt-2">
        <input
          name={name}
          className="checked:bg-secondary-light focus:ring-secondary-light focus:checked:bg-secondary-light hover:checked:bg-secondary-light
      rounded border-[#D0D5DD]
      "
          type='checkbox'
          {...input}
          {...checkboxProps}
        />
        <span className="text-text-color-mid-em dark:text-text-color-low-em label-md">
          {label}
        </span>
      </div>
    )}
  </Field>
);

export default FormFieldCheckbox;
